import type { PublicSignal } from "@/lib/api-client";
import type { LibraryItem } from "@/lib/mock/library";

const SIGNAL_ACCENT = "#22d3ee";

/**
 * Map a live signal (GET /alerts/signals) into a Library card item. The card's
 * mini trading-view chart reads `signal.curve` + the headline stats, so it
 * always reflects the signal's CURRENT numbers (updates as the signal updates).
 */
export function signalToLibraryItem(s: PublicSignal): LibraryItem {
  const perf = s.performance || {
    all_time_pct: 0,
    deployed_usd: 0,
    total_pnl_usd: 0,
    win_rate: 0,
    total_trades: 0,
    max_drawdown_pct: 0,
  };
  const curve = (s.equity_curve || [])
    .map((p) => p.value)
    .filter((v): v is number => typeof v === "number");

  return {
    id: s.id,
    kind: "signal",
    title: s.name,
    blurb: s.thesis || "",
    meta: "",
    accent: SIGNAL_ACCENT,
    topic: "",
    signal: {
      allTimePct: perf.all_time_pct,
      deployedUsd: perf.deployed_usd,
      profitUsd: perf.total_pnl_usd,
      winRate: perf.win_rate,
      totalTrades: perf.total_trades,
      openTrades: s.open_trades || 0,
      curve,
      featured: s.featured_position
        ? {
            name: s.featured_position.name,
            ticker: s.featured_position.ticker,
            direction: s.featured_position.direction,
            entry: s.featured_position.entry,
            currentPrice: s.featured_position.current_price,
            takeProfit: s.featured_position.take_profit,
            stop: s.featured_position.stop,
            trailPct: s.featured_position.trail_pct,
            timeExitDays: s.featured_position.time_exit_days,
            notionalUsd: s.featured_position.notional_usd,
            pnlPct: s.featured_position.pnl_pct,
            openedAt: s.featured_position.opened_at,
          }
        : null,
    },
  };
}
